import { render, staticRenderFns } from "./PageLanguages.vue?vue&type=template&id=b670349e&"
import script from "./PageLanguages.vue?vue&type=script&lang=js&"
export * from "./PageLanguages.vue?vue&type=script&lang=js&"
import style0 from "./PageLanguages.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports